import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator, fallback } from '@tanstack/zod-adapter'
import { AnalyticsOverview } from '@/components/analytics/analytics-overview'
import type { AnalyticsPeriod } from '@/lib/api/types'

const analyticsSearchSchema = z.object({
  period: fallback(z.enum(['7d', '30d', '90d']), '30d').default('30d'),
})

export const Route = createFileRoute('/_authenticated/analytics')({
  validateSearch: zodValidator(analyticsSearchSchema),
  component: AnalyticsPage,
})

function AnalyticsPage() {
  const { period } = Route.useSearch()
  const navigate = Route.useNavigate()

  const handlePeriodChange = (newPeriod: AnalyticsPeriod) => {
    navigate({ search: { period: newPeriod } })
  }

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      <AnalyticsOverview period={period} onPeriodChange={handlePeriodChange} />
    </div>
  )
}
